// ====================================================
// PDP GREY BANNERS — 11.11 SALE (Ends 12 November)
// Adds a grey promo banner above the price / offers block
// on matching product pages.
// ====================================================

(() => {
  "use strict";

  const BANNERS = [
  {
    "handles": [
      "prism-nanobot-pro"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBotPro.png?v=1792656122",
    "tag": "11.11 SALE",
    "title": "~~$200~~ $270 OFF Upsized Discount",
    "desc": "For every purchase of a Nanobot Pro",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "evosonic-ultra-detect-2-evopod"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoHuibElite.png?v=1790770180",
    "tag": "11.11 SALE",
    "title": "FREE EvoHub Elite (Worth $39.90)",
    "desc": "With every purchase of Evosonic Ultra 2 Dust Station Elite Accessories.",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-purefresh-tmf330-refrigerator",
      "prism-purefresh-tmf420-refrigerator",
      "purefresh-bmf-330",
      "prism-evershine-tmf420-refrigerator",
      "prism-evershine-tmf530-refrigerator"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Fridges_f4e22e67-a38b-412a-a32a-6857f3a27890.png?v=1790770217",
    "tag": "11.11 SALE",
    "title": "Limited Time Price Drop",
    "desc": "Only available with selected Fridge Models",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "inspire-fdr-570",
      "inspire-sbs-630",
      "prism-purefresh-fdr-440-four-door-refrigerator",
      "purefresh-fdr-570",
      "prism-purefresh-sbs600-refrigerator",
      "purefresh-sbsi-560"
    ],
    "image": "https://prismplus.sg/cdn/shop/files/Vortex_2c.jpg?v=1792854181",
    "tag": "11.11 SALE",
    "title": "FREE Vortex 2c Air Purifier (Worth $209)",
    "desc": "Only available for Four Door & Side by Side Fridges",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-cyclone-washer-dryer-bundle",
      "prism-washer-dryer-bundles",
      "laundry-rack-and-washer-bundle"
    ],
    "image": "https://prismplus.sg/cdn/shop/files/Vortex_2c.jpg?v=1792854181",
    "tag": "11.11 SALE",
    "title": "FREE Vortex 2c Air Purifier (Worth $209)",
    "desc": "Applicable to all Laundry Rack, Washer & Dryer Bundles",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-mini-combo"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Spin.png?v=1788284314",
    "tag": "11.11 SALE",
    "title": "~~$100~~ $150 OFF Upsized Discount",
    "desc": "For every purchase of a Spin Mini Wash & Dry",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-spectre-bundle-2026"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/spectre-free-sale.png?v=1788779734",
    "tag": "11.11 SALE",
    "title": "~~$200~~ $250 OFF Upsized Discount",
    "desc": "Applicable for only Spectre Lock Bundle",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-u55-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-u65-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-u75-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-u86-ultra-qd-mini-led-4k-ai-google-tv",
      "prism-55al-google-tv",
      "prism-65al-google-tv"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/TV_Soundbar_436bfb28-bfd6-41d7-9c97-135f0a68e6fc.png?v=1791429899",
    "tag": "11.11 SALE",
    "title": "Upsized Discount for Soundbar Bundles",
    "desc": "Across all TV Series",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "u55-2026",
      "u65-2026",
      "q43u-2026",
      "q55u-2026",
      "q65u-2026"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/TV_Soundbar_436bfb28-bfd6-41d7-9c97-135f0a68e6fc.png?v=1791429899",
    "tag": "11.11 SALE",
    "title": "Upsized Discount for Soundbar Bundles",
    "desc": "Across all TV Series",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "u75-2026",
      "u75-qled-mini-led-google",
      "q75u-2026",
      "q85u-2026",
      "prism-q100-ultra-qled-google-tv"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/TV_Soundbar_436bfb28-bfd6-41d7-9c97-135f0a68e6fc.png?v=1791429899",
    "tag": "11.11 SALE",
    "title": "Upsized Discount for Soundbar Bundles",
    "desc": "Across all TV Series",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "q43qe-2026",
      "q55qe-2026",
      "q65qe-2026",
      "q75qe-2026",
      "s32-google-tv",
      "prism-s40-google-tv",
      "prism-s43-google-tv"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/TV_Soundbar_436bfb28-bfd6-41d7-9c97-135f0a68e6fc.png?v=1791429899",
    "tag": "11.11 SALE",
    "title": "Upsized Discount for Soundbar Bundles",
    "desc": "Across all TV Series",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-roam-27"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Roam.png?v=1790770558",
    "tag": "11.11 SALE",
    "title": "~~$200~~ $350 OFF Upsized Discount",
    "desc": "For every purchase of a Roam 27",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-roam-ultra-27"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Roam.png?v=1790770558",
    "tag": "11.11 SALE",
    "title": "~~$200~~ $400 OFF Upsized Discount",
    "desc": "For every purchase of a Roam Ultra 27",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "roam-ultra-32"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Roam.png?v=1790770558",
    "tag": "11.11 SALE",
    "title": "~~$200~~ $250 OFF Upsized Discount",
    "desc": "For every purchase of a Roam Ultra 32",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-pg25x-pro",
      "prism-pg27x-pro",
      "prism-pg27f-ultra",
      "prism-pg400u-pro",
      "prism-x490",
      "prism-x490-pro"
    ],
    "images": {
      "prism-pg25x-pro": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/PG25XPRO_ee9f43e4-f2d6-4a5b-98b3-1778c4cab46f.png?v=1790771123",
      "prism-pg27x-pro": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/PG25XPRO_ee9f43e4-f2d6-4a5b-98b3-1778c4cab46f.png?v=1790771123",
      "prism-pg27f-ultra": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/PG25XPRO_ee9f43e4-f2d6-4a5b-98b3-1778c4cab46f.png?v=1790771123",
      "prism-pg400u-pro": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/PG400UPRO.png?v=1790771123",
      "prism-x490": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/X490_89579d39-76e9-4bad-9329-ecad4d231e5e.png?v=1790771123",
      "prism-x490-pro": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/X490_89579d39-76e9-4bad-9329-ecad4d231e5e.png?v=1790771123"
    },
    "tag": "11.11 SALE",
    "title": "Limited Time Price Drop",
    "desc": "Only available with selected monitor models",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-49al"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/49AL_30c834d5-3a69-496c-adad-ebcbd4261f4e.png?v=1790770692",
    "tag": "11.11 SALE",
    "title": "~~$70~~ $230 OFF Upsized Discount",
    "desc": "For every purchase of a 49AL",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-49al-240hz"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/49AL_30c834d5-3a69-496c-adad-ebcbd4261f4e.png?v=1790770692",
    "tag": "11.11 SALE",
    "title": "~~$70~~ $210 OFF Upsized Discount",
    "desc": "For every purchase of a 49AL 240Hz",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-symphony-soundbar",
      "ripple-soundbar",
      "prism-rhythm",
      "prism-flow-soundbar"
    ],
    "images": {
      "prism-symphony-soundbar": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Symphony.png?v=1790771130",
      "ripple-soundbar": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/RIpple.png?v=1790771130",
      "prism-rhythm": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Rhythm_441e681f-80fc-44c1-94ae-240521bdd2f3.png?v=1790771129",
      "prism-flow-soundbar": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Flow.png?v=1790771129"
    },
    "tag": "11.11 SALE",
    "title": "Limited Time Price Drop",
    "desc": "Available for all Soundbars",
    "extra": "Offer ends 12 November"
  },
  {
    "handles": [
      "prism-nanobot-elite-ai"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBotEliteAI_21c57bfb-a683-4290-bced-d017934597e2.png?v=1790770148",
    "tag": "11.11 SALE",
    "title": "Free 2x Cleaning Solution (Worth $47.80) + Vortex 2c Air Purifier (Worth $209)",
    "desc": "Only for NanoBot Elite AI",
    "extra": "Offer ends 12 November"
  }
];
  function appendText(el, text) {
    text.split(/~~(.+?)~~/).forEach((part, i) => {
      if (!part) return;
      if (i % 2) {
        const strike = document.createElement("s");
        strike.textContent = part;
        el.append(strike);
      } else {
        el.append(part);
      }
    });
  }

  function productImage() {
    const meta =
      document.querySelector('meta[property="og:image:secure_url"]') ||
      document.querySelector('meta[property="og:image"]');
    return meta ? meta.content : "";
  }

  function createBanner({ image, tag, title, desc, extra }) {
    const wrapper = document.createElement("div");
    wrapper.className = "free_gift_banner layout2";
    wrapper.style.display = "block";

    const gift = document.createElement("div");
    gift.className = "free-gift comex";

    const img = document.createElement("img");
    img.src = image || productImage();
    img.alt = "";

    const info = document.createElement("div");
    info.className = "info-wrapper";

    const titleWrapper = document.createElement("div");
    titleWrapper.className = "title-wrapper";

    const tagEl = document.createElement("span");
    tagEl.className = "free-tag";
    appendText(tagEl, tag);

    const titleEl = document.createElement("span");
    titleEl.className = "title";
    appendText(titleEl, title);

    titleWrapper.append(tagEl, titleEl);
    info.append(titleWrapper);

    if (desc) {
      const descEl = document.createElement("p");
      descEl.className = "description";
      appendText(descEl, desc);
      info.append(descEl);
    }

    if (extra) {
      const extraEl = document.createElement("span");
      extraEl.className = "description red";
      appendText(extraEl, extra);
      info.append(extraEl);
    }

    gift.append(img, info);
    wrapper.append(gift);
    return wrapper;
  }

  const prodHandle = location.pathname.split("/").pop();
  const matches = BANNERS.filter((banner) => banner.handles.includes(prodHandle));
  if (!matches.length) return;

  function init() {
    const target =
      document.querySelector('[itemprop="offers"]') ||
      document.querySelector(".variant-selector") ||
      document.querySelector(".product-form");

    if (!target || !target.parentNode) return;

    const banners = matches.map((banner) => {
      const image = (banner.images && banner.images[prodHandle]) || banner.image;
      const el = createBanner({ ...banner, image });
      target.parentNode.insertBefore(el, target);
      return el;
    });

    keepAboveAddon(banners);
  }

  function keepAboveAddon(banners) {
    const meta = document.querySelector(".product-single__meta");
    if (!meta) return;

    const moveAboveAddon = () => {
      const addon = meta.querySelector(":scope > .addon-section");
      if (!addon) return false;
      addon.before(...banners);
      return true;
    };

    if (moveAboveAddon()) return;

    const observer = new MutationObserver(() => {
      if (moveAboveAddon()) observer.disconnect();
    });
    observer.observe(meta, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
